import { render, staticRenderFns } from "./SplashPopup.vue?vue&type=template&id=1f2284ba&scoped=true&"
import script from "./SplashPopup.vue?vue&type=script&lang=js&"
export * from "./SplashPopup.vue?vue&type=script&lang=js&"
import style0 from "./SplashPopup.vue?vue&type=style&index=0&id=1f2284ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2284ba",
  null
  
)

export default component.exports